import React from "react";

function TextAreaInput(props) {   
  const { t } = props;
  const errors = props.validation && props.validation.errors ? props.validation.errors : "";
  const isDirty = props.validation && props.validation.dirty ? props.validation.dirty : false;
  const formClass = errors[props.name] && isDirty[props.name] ? "form-group invalid" : "form-group";
  return (
    <div className={formClass}>
      <label htmlFor={props.id}>{props.label}</label>
      <textarea
        id={props.id}
        name={props.name}
        value={props.value}
        type="text"
        className="form-control"
        placeholder={props.placeholder}
        onChange={props.onChange}
        required={props.required}
        rows={props.rows} 
        maxLength={props.maxLength}  
      ></textarea>
      {errors[props.name] && isDirty[props.name] && (<div className="error-message">{t(errors[props.name])}</div>)}
      {/* {props.error.length && } */}
    </div>
  );
}
export default TextAreaInput;
